import request from '@/utils/request'

export function getList(data) {
  return request({
    method:'post',
    url:`/yzdservice/enterprise/yjpz/getList`,
    data:data
  })
}

export function changeStatusPut(kqzt,id) {
  return request({
    method:'put',
    url:`/yzdservice/enterprise/yjpz/changeGayjStatus/${id}/${kqzt}`
  })
}

export function changeStatusTqyjPut(kqzt,id) {
  return request({
    method:'put',
    url:`/yzdservice/enterprise/yjpz/changeTqyjStatus/${id}/${kqzt}`
  })
}
